import useWeatherAnimation from '@/DesignSystem/features/weather/useWeatherAnimations';
import { Box } from '@mui/material';
import { useState } from 'react';
import PrediccionDelTiempo from '../complementos/PrediccionDelTiempo';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';

const useIconoEstadoDelTiempo = (prediccionTiempo, position = 'right') => {
    const [openPrediccionDelTiempo, setOpenPrediccionDelTiempo] = useState(false);
    const estadoCielo = prediccionTiempo?.estadoCielo?.[0]?.value;
    const icono = useWeatherAnimation(estadoCielo, 60);

    // ✅ Posición dinámica: derecha por defecto, izquierda opcional
    const positionStyles = position === 'left' ? { top: 5, left: 5 } : { top: 5, right: 5 };

    const onClick = () => {
        setOpenPrediccionDelTiempo(true);
    };

    return (
        <>
            <CustomTooltip label={'Ver predicción del tiempo'}>
                <Box
                    position={'absolute'}
                    {...positionStyles}
                    zIndex={1000}
                    onClick={onClick}
                    sx={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    {icono}
                </Box>
            </CustomTooltip>
            {openPrediccionDelTiempo && (
                <PrediccionDelTiempo
                    prediction={prediccionTiempo}
                    open={openPrediccionDelTiempo}
                    onClose={() => setOpenPrediccionDelTiempo(false)}
                />
            )}
        </>
    );
};

export default useIconoEstadoDelTiempo;
